import { createSlice } from '@reduxjs/toolkit';

export type AuthSliceType = {
  isLoading: boolean;
  isLoggedIn: boolean;
  user: {
    name?: string;
    avatar?: string;
    token?: string;
    permissions?: { id: number; name: string; action: number }[];
  };
  error?: Object;
};

const initialState: AuthSliceType = {
  isLoading: true,
  isLoggedIn: false,
  user: {},
  error: undefined
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    LOGIN: (state, action) => ({ ...state, isLoading: true }),
    LOGIN_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isLoggedIn: true,
      user: payload
    }),
    LOGIN_FAILURE: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error
    })
  }
});

const { actions, reducer } = authSlice;

export const { LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE } = actions;
export default reducer;
